import { withCompInfo } from '@wix/editor-elements-integrations'
import { TinyMenuCSSVars, TinyMenuDefinition } from './TinyMenu'
import { colorApi } from '@wix/thunderbolt-becky-root'
import { isFixedPosition as fixedPosition, getTopCSS, getLeftCSS } from '@wix/editor-elements-common-utils'

const WIX_ADS_HEIGHT = 38

const isClassicSkin = (skin: TinyMenuDefinition['skin']) => skin === 'TinyMenuSkin'

export const css = withCompInfo<TinyMenuCSSVars, TinyMenuDefinition>()(
	// @ts-ignore - remove once siteWidth is added to CompInfo
	[
		'compLayout',
		'styleProperties',
		'skin',
		// @ts-ignore
		'siteWidth',
		'siteColors',
		// @ts-ignore
		'shouldShowFreemiumBanner',
		'compSingleLayout',
	],
	// @ts-ignore - remove once siteWidth is added to CompInfo
	({ compLayout, styleProperties, skin, siteWidth, siteColors, shouldShowFreemiumBanner, compSingleLayout }) => {
		const isFixedPosition = fixedPosition(compLayout, compSingleLayout)
		const strokeWidth = styleProperties.strokewidth
		const xPosition = getLeftCSS(compLayout, compSingleLayout)
		const yPosition = getTopCSS(compLayout, compSingleLayout)

		const btnPaddingTop = strokeWidth && {
			'--btn-padding-top': `${((parseInt(strokeWidth, 10) % 2) * -1 + 1) / 2}px`,
		}

		const buttonMarginTop = isFixedPosition &&
			shouldShowFreemiumBanner && {
				'--btn-margin-top': `${WIX_ADS_HEIGHT}px`,
			}

		const containerPaddingTop = shouldShowFreemiumBanner && {
			'--container-padding-top': `${WIX_ADS_HEIGHT}px`,
		}

		const rootStyles = isFixedPosition && {
			'margin-left': `calc(50% - ${siteWidth ? siteWidth / 2 : 0}px)`,
			position: 'fixed',
			'--top': yPosition,
			left: xPosition,
			'--root-z-index': 50,
		}

		const brightnessParams = colorApi.getBrightnessCSSVars<
			Pick<TinyMenuCSSVars, '--counter-color-mutated-brightness'>
		>({
			paramName: 'counterColor',
			mutatedParamName: 'counter-color',
			fallbackName: 'txt',
			alpha: 2,
			siteColors,
			styleProperties,
		})

		const containerMarginLeft = isClassicSkin(skin) && {
			'--container-margin-left': `${parseInt(xPosition!, 10) ? `-${xPosition}` : 0}`,
		}

		const fixInvalidBg = styleProperties.bg === '###' && {
			'--bg': 'var(--color_15)',
		}

		return {
			...brightnessParams,
			...btnPaddingTop,
			...buttonMarginTop,
			...containerPaddingTop,
			...containerMarginLeft,
			...rootStyles,
			...fixInvalidBg,
		}
	}
)
